/** Root layout wrapper — global chrome lives in PlatformShellLayout / AppShell. */
export default function AppLayout({ children }) {
  return children;
}
